// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ToggleButton from 'vue-js-toggle-button'
//import Cookie from 'vue-cookie'
import router from './router/router'
import store from './vuex/store'

window._        = require('lodash')
window.$        = window.jQuery = require('jquery')
window.modal    = require('jquery-modal')
window.PopperJs = require('popper.js')

// Persiste as credenciais da URL antes da inicializacao do Vue Router e dos
// interceptors. No ambiente de desenvolvimento, aguardar o App.beforeCreate
// pode fazer a navegacao inicial acontecer sem que o token esteja disponivel.
const queryParams = new URLSearchParams(window.location.search)
const token = queryParams.get('token')
const refreshToken = queryParams.get('refresh_token')

if (token) {
  localStorage.setItem('token', token)
  localStorage.setItem('refresh_token', refreshToken || '')
  localStorage.removeItem('fastLogin')
}

// require('bootstrap')

require('../../core/scripts/util')
require('../../core/scripts/collapse')
require('bootstrap/js/dist/popover')
// require('./resources/config')
require('./filters')
require('./components')

Vue.config.productionTip = false
Vue.use(ToggleButton)
//Vue.use(Cookie)

let resources = require('../../core/resources/config')

Vue.prototype.$filters    = Vue.options.filters
Vue.prototype.$resources  = resources.default

import methods from './methods'

window.app = new Vue({
  el: '#app',
  data: function(){
    return {
      loadApp: false,
      silentLoading: false,
      showLoading: false,
      textLoading: null,
      avisoCarrinho: false,
      alert: {
        texto: null,
        tipo: 'primary',
        titulo : null
      },
      errorsForm: {},
      to: null,
    }
  },
  methods: methods,
  head: {
    title: function(){
      return {
        inner: this.$route.meta.title ? this.$route.meta.title : 'Loja'
      }
    }
  },
  watch: {
    '$route': function () {
      this.$emit('updateHead')
      this.$root.alert.texto = null
      this.$root.alert.tipo = 'primary'
    }
  },
  router,
  store,
  components: { App },
  template: '<App/>'
})

router.onReady((to) => {
  app.avisoCarrinho = to.meta.avisoCarrinho
  if(to.meta.login && !app.isAutenticaded()){
    let search = _.cloneDeep(location.search).slice(1).split('&')
    let continueApp = true

    if (_.isArray(search)) {
      _.forEach(search, s => {
        let param = s.split('=')
        if (_.isArray(param) && _.size(param) == 2 && param[1] != '') {
          let key = param[0]
          if (key == 'token' || key == 'refresh_token') {
            localStorage.setItem(key, param[1].trim())
            continueApp = false
          }
        }
      })
    }

    app.to = to.name

    if (continueApp) {
      router.push({name: 'autenticacao'})
    }
  }
  else{
    app.to = null
  }
})

router.beforeEach((to, from, next) => {
    $('.dropdown-menu').hide()
  app.silentLoading = false
  app.showLoading = true
  app.textLoading = null
  app.avisoCarrinho = to.meta.avisoCarrinho
  if(to.meta.login && !app.isAutenticaded()){
    app.to = to.name
    next({name: 'autenticacao'})
  }
  else{
    //app.to = null
    next()
  }
})

router.afterEach(() => {
  app.showLoading = false
  app.textLoading = null
})



// WEBPACK FOOTER //
// ./src/main.js